import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { Link, useNavigate } from 'react-router-dom';


const SignUp = () => {
    const navigate = useNavigate();



    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm({ mode: 'onTouched' });

    const userHandle = async (data) => {
        const user = {
            name: data.name,
            phone: data.phone,
            password: data.password
        }
        console.log(user)
        const phoneData = data.phone;
        fetch(`${process.env.REACT_APP_SECRET_API}/user-register`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(user),
        })
            .then((res) => res.json())
            .then((data) => {

                if (data.success === true) {
                    toast.success(data.message);
                    navigate('/otp-verify')
                    localStorage.setItem('phone', phoneData)
                } else {
                    toast.error(data.message);

                }
                reset()
            })
    }

    const password = watch('password');
    const [toggle1, setToggle1] = useState(false);
    const [toggle2, setToggle2] = useState(false);
    const handleShowPassword = () => {
        setToggle2(!toggle2);
    }

    return (
        <div>
            <div className="contain py-16">
                <div className="max-w-md bg-white mx-auto shadow px-6 py-7 rounded overflow-hidden">
                    <h2 className="lg:text-2xl text-[20px] uppercase font-medium text-center text-black mb-1">Create an account</h2>
                    <p className="text-gray-600 mb-6 text-center text-sm">
                        Register for new customer
                    </p>
                    <div className="divider"></div>
                    <form onSubmit={handleSubmit(userHandle)}>
                        <div className="space-y-2">
                            <div>
                                <label htmlFor="name" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Full Name</label>
                                <input type="text" name="name" id="name"
                                    className="block bg-white w-full border border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="Your Name"
                                    {...register("name", {
                                        required: {
                                            value: true,
                                            message: "Name is Required"
                                        },
                                        pattern: {
                                            value: /[a-z]/,
                                            message: "only letter."
                                        },
                                        minLength: {
                                            value: 3,
                                            message: "Al least 3 characters"
                                        },
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.name?.message}</span>
                            </div>
                            <div>
                                <label htmlFor="number" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Phone Number</label>
                                <input type="text" name="number"
                                    className="block bg-white w-full border border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="012345678901"
                                    {...register("phone", {
                                        required: {
                                            value: true,
                                            message: "Number is Required"
                                        },
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: "Only give number."
                                        },
                                        minLength: {
                                            value: 11,
                                            message: "Must be 11 digits"
                                        },
                                        maxLength: {
                                            value: 11,
                                            message: "No more than 11 digits can be given"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.phone?.message}</span>
                            </div>

                            <div>
                                <label htmlFor="number" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Password</label>

                                {/* icon show password */}

                                {(toggle1 === false) ? <RiEyeOffLine className='text-black cursor-pointer absolute mt-3 ml-[350px]' onClick={() => setToggle1(!toggle1)}></RiEyeOffLine> : <RiEyeLine className='text-red-500 cursor-pointer absolute mt-3 ml-[350px]' onClick={() => setToggle1(!toggle1)}></RiEyeLine>}


                                <input type={toggle1 ? "text" : "password"} name="number"
                                    className="block bg-white w-full border border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="••••••••"
                                    {...register("password", {
                                        required: {
                                            value: true,
                                            message: "password is Required"
                                        },
                                        // pattern: {
                                        //     value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                                        //     message: "Minimum six characters, at least one letter and one number"
                                        // },
                                        minLength: {
                                            value: 6,
                                            message: "Must be exceed 6 characters"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.password?.message}</span>
                            </div>

                            <div>
                                <label htmlFor="confirm_password" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Confirm Password</label>

                                {/* icon show password */}

                                {
                                    (toggle2 === false) ? <RiEyeOffLine className='text-black cursor-pointer absolute mt-3 ml-[350px]' onClick={handleShowPassword}></RiEyeOffLine> : <RiEyeLine className='text-red-500 cursor-pointer absolute mt-3 ml-[350px]' onClick={handleShowPassword}></RiEyeLine>
                                }


                                <input type={toggle2 ? "text" : "password"} name="number"
                                    className="block bg-white w-full border border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="••••••••"
                                    {...register("confirmpassword", {
                                        required: {
                                            value: true,
                                            message: "confirm password is required"
                                        },
                                        // pattern: {
                                        //     value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                                        //     message: "Minimum six characters, at least one letter and one number"
                                        // },
                                        validate:
                                            value => value === password || "The password do not match",
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.confirmpassword?.message}</span>
                            </div>
                        </div>

                        <div className="mt-4">
                            <button type="submit"
                                className="block w-full py-2 text-center text-white  border border-primary rounded bg-gradient-to-r from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary transition uppercase font-roboto font-medium">
                                    Sign Up
                            </button>
                        </div>
                    </form>
                    <p className="mt-4 text-center lg:text-[14px] text-sm text-gray-600">Already have account? <Link to="/login"
                        className="text-primary">Login now</Link></p>
                </div>
            </div>
        </div>
    );
};

export default SignUp;